<template>
  <Card :header="headerName">
    <template #header-actions>
      <div class="card-color-info" v-if="colorInfo">
        <div
          class="item-status"
          v-for="(headItem, j) in headerLegends"
          :key="j"
        >
          <div :class="['circle', headItem.class]"></div>
          <div class="item-text">
            {{ headItem.name }}
          </div>
        </div>
      </div>
    </template>
    <template #card-body>
      <div class="cardBody-scroll">
        <Loading v-if="loading" />
        <NoData
          v-if="items.length == 0 && !loading"
          :message="$t('noData')"
        ></NoData>
        <div v-if="!loading">
          <div v-for="(item, i) in items" :key="i" class="progress-body">
            <div class="progress-header-content">
              <div class="header-colored" v-if="!progressHeaderColor">
                <div class="progress-header-content-identifier">
                  {{ item.total.data.label }}
                </div>
              </div>
              <div v-if="progressHeaderColor" class="header">
                <div class="progress-header-content-identifier">
                  {{ item.total.data.label }}
                </div>
              </div>
              <div v-if="showTotal" class="total-color">
                {{ item.total.textValue }} :
              </div>
              <div v-if="showTotal" class="total-value-color">
                {{
                  item.total.formatData
                    ? getDataInGB(item.total.data.value)
                    : item.total.data.value
                }}
              </div>
              <div class="progress-info" v-if="showProgressTop">
                <div class="progress-info-content">
                  <div class="progress-info-content-identifier-value">
                    {{
                      item.used.formatData
                        ? getDataInGB(item.used.data.value)
                        : item.used.data.value
                    }}
                  </div>

                  <div class="progress-info-content-identifier">
                    {{ item.used.textValue }}
                  </div>
                </div>
                <div class="progress-info-content">
                  <div
                    :class="
                      getValueColor(item.used.data.value, item.total.data.value)
                    "
                  >
                    {{
                      item.available.formatData
                        ? getDataInGB(item.available.data.value)
                        : item.available.data.value
                    }}
                  </div>
                  <div class="progress-info-content-identifier">
                    {{ item.available.textValue }}
                  </div>
                </div>
              </div>
            </div>
            <div class="progress-bar-content">
              <RexProgress
                :precent="
                  item.used.formatData
                    ? item.total.data.value > 0
                      ? (Number(item.used.data.value) /
                          Number(item.total.data.value)) *
                        100
                      : 0
                    : item.used.data.value
                "
                :color="color"
              />
            </div>
            <div class="progress-tail" v-if="!showProgressTop">
              <div class="progress-tail-content">
                <div class="progress-tail-content-identifier">
                  {{ item.used.textValue }}:
                </div>
                <div class="progress-tail-content-identifier-value">
                  {{
                    item.used.formatData
                      ? getDataInGB(item.used.data.value)
                      : item.used.data.value
                  }}
                </div>
              </div>
              <div class="progress-tail-content ml-4">
                <div class="progress-tail-content-identifier">
                  {{ item.available.textValue }}:
                </div>
                <div class="progress-tail-content-identifier-value">
                  {{
                    item.available.formatData
                      ? getDataInGB(item.available.data.value)
                      : item.available.data.value
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/rex-components/rex-card.vue';
import RexProgress from '@/rex-components/rex-progress.vue';
import NoData from '@/rex-components/rex-no-data.vue';
import { getDataInGB } from '@/utils/helper-function';
import Loading from '@/rex-components/rex-loading.vue';

/**
 * Info status is used to display icon and text together with label.
 */
export default {
  name: 'RexProgressCard',
  components: { Card, RexProgress, NoData, Loading },

  props: {
    showProgressTop: {
      type: Boolean,
      default: false,
    },
    progressHeaderColor: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
    showTotal: {
      type: Boolean,
      default: true,
    },
    /**
     * The name for the header of the progress card
     */
    headerName: {
      type: String,
      required: true,
      default: 'Progress Stats Card',
    },
    /**
     * An array of header legends that needs to displayed and each object will have "name" that needs to be displayed and "class" of the legends which contains the color of the legends
     */
    headerLegends: {
      type: Array,
      default: () => [
        { name: 'legend1', class: 'primary' },
        { name: 'legend2', class: 'secondary' },
      ],
    },
    // TODO: make improvements
    progressHeaderColors: {
      type: Object,
      default: () => ({
        totalHeader: 'Total memory',
      }),
    },

    colorInfo: {
      type: Boolean,
      default: true,
    },
    /**
     *
     *For component level loading
     *
     */
    loading: { type: Boolean, default: false },
    /**
     * The data object that needs to be rendered on the progress bar
     */
    items: {
      type: Array,
      // required: true,
      default: () => [],
    },
  },
  methods: {
    getDataInGB,
    getValueColor(used, total) {
      if (Number(used) < Number(total / 2)) {
        return 'green-color-text';
      } else if (Number(used) < Number((total * 3) / 4)) {
        return 'yellow-color-text';
      } else {
        return 'red-color-text';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  padding: 1rem;
}

.circle {
  width: 0.8125rem;
  height: 0.8125rem;
  border-radius: 50%;
  margin-top: 0.1875em;
  margin-right: 0.5em;
}
.primary {
  background-color: $progress-active-color;
  color: $progress-active-color;
}
.secondary {
  background-color: $progress-inactive-color;
  color: $progress-inactive-color;
}

.card-color-info {
  display: flex;
}
.item-status {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1.375em;
  justify-content: center;
}
.item-text {
  line-height: 1.375em;
  font-size: 1.125em;
  text-align: center;
  font-family: $regular;
  background-color: transparent !important;
  color: $color-brand-accent !important;
}
.progress-header-content {
  display: flex;
}
.header-colored .progress-header-content-identifier {
  color: $color-brand-accent;
  width: auto;
  text-align: left;
  margin-right: 0.75rem;
}

.header .progress-header-content-identifier {
  width: auto;
  text-align: left;
}
.progress-tail-content-identifier-nocolor {
  width: auto;
  text-align: left;
  font-size: 0.75rem;
}
.progress-tail-content-identifier {
  color: $color-brand-accent;
  width: auto;
  text-align: left;
  font-size: 0.75rem;
}
.progress-tail-content-identifier-value {
  color: $font-tertiary;
  width: auto;
  text-align: left;
  margin-left: 0.3125rem;
  font-size: 0.75rem;
}
.progress-tail {
  display: flex;
  margin-bottom: 0.935rem;
}
.progress-tail-content {
  display: flex;
}
.progress-bar-content {
  margin-top: 0.75rem;
  margin-bottom: 0.3125rem;
}
.progress-bar-info {
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  color: #28292a;
}
.progress-body {
  margin-bottom: 0.6875rem;
  border-bottom: $border-primary 0.5px solid;
}
.progress-body:last-child {
  border-bottom: none;
}
.progress-info {
  display: flex;
  margin-top: 0.1rem;
  margin-left: auto;
}
.progress-info-content {
  display: flex;
  margin-left: 5rem;
  font-weight: bold;
}
.progress-info-content-identifier-value {
  font-size: 0.8rem;
  margin-right: 0.5rem;
}
.progress-info-content-identifier {
  color: $font-tertiary;
  width: auto;
  text-align: left;
  font-size: 0.8rem;
}

.yellow-color-text {
  font-size: 0.9rem;
  margin-right: 0.5rem;
  color: $progress-yellow;
  font-weight: bold;
}

.red-color-text {
  color: $progress-red;
  font-size: 0.9rem;
  margin-right: 0.5rem;
  font-weight: bold;
}

.green-color-text {
  color: $progress-green;
  font-size: 0.9rem;
  margin-right: 0.5rem;
  font-weight: bold;
}
:deep(.card-body) {
  padding: 0.8rem;
}

.cardBody-scroll {
  overflow: auto;
  max-height: 17rem;
  padding-right: 0.5rem;
}
</style>
